import React, { useContext } from 'react';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Copyright from './copyright.component/copyright'
import ControlTouchpad from './control.components/ControlTouchpad';
import ControlBlower from './control.components/ControlBlower';
import ControlLight from './control.components/ControlLight';
import ControlRebootController from './control.components/ControlRebootController';
import ControlTestMode from './control.components/ControlTestMode';
import { MainRfContext } from '../context/MainRfContext';
import { MainContext } from '../context/MainContext';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import ControlLightMode from './control.components/ControlLightMode';
import ControlPumps from "./control.components/ControlPumps";
import ControlBlowers from "./control.components/ControlBlowers";
import ControlLightAnimate from "./control.components/ControlLightAnimate";
import ControlFastHeat from "./control.components/ControlFastHeat";

function ControlContent() {
  const state = useContext(MainRfContext);
  const hasHeatNowFunction = state.RC && state.RC.split(',').length >= 18;

  if ((state.selectedDevice === 0)) {
    return (<Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Stack sx={{ width: '100%' }} spacing={2}>
        <Alert variant="filled" severity="error">
          No spa associated with this account
        </Alert>
      </Stack>
    </Container>)
  } else if (!state.R2 || !state.RG) {
    return (<Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Stack sx={{ width: '100%', pt: 2, pl: 3 }} spacing={2}>
        <Alert variant="filled" severity="error">
          No RF Data Available
        </Alert>
      </Stack>
    </Container>)
  } else {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <MainContext.Provider value={{ state }}>
          <Grid container spacing={3}>
            {/* Offline */}
            {state.online === false ? <Stack sx={{ width: '100%', pt: 2, pl: 3 }} spacing={2}>
              <Alert variant="filled" severity="error">
                Spa is Offline
              </Alert>
            </Stack> : <div></div>}
            {/* Pumps */}
            <Grid item xs={22} md={22} lg={22}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', backgroundColor: 'black' }}>
                <ControlPumps />
              </Paper>
            </Grid>
            {state.R3.split(',')[7] === "SV1" || state.R3.split(',')[7] === "SVM1" || hasHeatNowFunction ? (
              <>
                {/* Fast Heat */}
                <Grid item xs={22} md={22} lg={22}>
                  <Paper
                    sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      backgroundColor: 'black'
                    }}
                  >
                    <ControlFastHeat />
                  </Paper>
                </Grid>
              </>
            ) : (
              <>
                {/* Blowers */}
                <Grid item xs={22} md={22} lg={22}>
                  <Paper
                    sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      backgroundColor: 'black'
                    }}
                  >
                    <ControlBlowers />
                  </Paper>
                </Grid>
              </>
            )}

            {/* Light Mode */}
            <Grid item xs={22} md={22} lg={22}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', backgroundColor: 'black' }}>
                <ControlLightMode />
              </Paper>
            </Grid>
            {/* Reboot Controller */}
            <Grid item xs={22} md={22} lg={22}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', backgroundColor: 'black' }}>
                <ControlRebootController />
              </Paper>
            </Grid>
          </Grid>
        </MainContext.Provider >
        <Copyright sx={{ pt: 4 }} />
      </Container >
    );
  }
}

export default function Control() {
  return <ControlContent />;
}